import React from 'react'

import { Loader } from 'goustouicomponents'

import { formatPrice } from 'routes/Signup/signupUtils'

import { BoxDescriptionPlaceholderType } from '../types'

import css from './PricePerNRecipesTable.css'

type PricePerNRecipesTableProps = {
  isLoadingPrices: boolean
  boxDescriptors: BoxDescriptionPlaceholderType[]
}

export const PricePerNRecipesTable = ({
  isLoadingPrices,
  boxDescriptors,
}: PricePerNRecipesTableProps) => (
  <div className={css.pricesPerRecipesTableContainer}>
    <div className={css.row}>
      {isLoadingPrices ? (
        <Loader color="Bluecheese" />
      ) : (
        boxDescriptors.map((boxDescriptor) => {
          const nRecipes = boxDescriptor.num_portions
          const { totalAfterDiscount } = boxDescriptor
          const totalBeforeDiscount = boxDescriptor.total

          const isDiscounted = totalAfterDiscount !== totalBeforeDiscount

          return (
            <div className={css.cell} key={nRecipes}>
              <div className={css.nRecipesLine}>{nRecipes} recipes</div>
              <div className={css.priceLine}>{formatPrice(totalAfterDiscount)}</div>
              <div className={css.priceBeforeDiscountLine}>
                {isDiscounted && formatPrice(totalBeforeDiscount)}
              </div>
            </div>
          )
        })
      )}
    </div>
  </div>
)
